import { render, staticRenderFns } from "./newsportage-out-inner.vue?vue&type=template&id=62ae370b&scoped=true"
import script from "./newsportage-out-inner.vue?vue&type=script&lang=js"
export * from "./newsportage-out-inner.vue?vue&type=script&lang=js"
import style0 from "./newsportage-out-inner.vue?vue&type=style&index=0&id=62ae370b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ae370b",
  null
  
)

export default component.exports